export const NewScheduleCleaning = "Upload New Cleaning Schedule"
export const UploadFile = "Upload File"
export const Upload = "Upload"
export const Download = "Download Latest Schedule"
export const Uploading = "Uploading"
export const FileUploaded = "File uploaded successfully.."
export const FileName= "File Name"
export const UploadDate = "Upload Date"
export const UploadHistory = "No upload history available"
export const EmptyUploadFile = "Invalid Cleaning Schedule format"
